import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FullCalendarModule } from 'ng-fullcalendar';
import { DragulaModule } from 'ng2-dragula';
import { EmbedVideo } from 'ngx-embed-video';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
// import { EmbedVideo } from 'ngx-embed-video';
// import { UiSwitchModule } from 'ngx-ui-switch';
import { TooltipModule } from 'ngx-tooltip';
import { AppRoutingModule } from './app-routing.module';
// import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
// import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { AppComponent } from './app.component';
import { ApiInterceptor } from './services/api-interceptor/api-interceptor';
import { BranchService } from './services/branch/branch.service';
import { EventService } from './services/event/event.service';
import { HelperService } from './services/helper/helper.service';
import { LoggerService } from './services/logger/logger.service';
import { AuthGuardService } from './services/route-guards/auth-guard/auth-guard.service';
import { NoAuthGuardService } from './services/route-guards/no-auth-guard/no-auth-guard.service';
import { UiService } from './services/ui/ui.service';
import { UserService } from './services/user/user.service';
import { SharedModule } from './shared/shared.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    SharedModule,
    FullCalendarModule,
    DragulaModule.forRoot(),
    TooltipModule,
    MalihuScrollbarModule.forRoot(),
    EmbedVideo.forRoot(),
  ],
  declarations: [AppComponent],
  providers: [
    UiService,
    HelperService,
    UserService,
    AuthGuardService,
    NoAuthGuardService,
    EventService,
    LoggerService,
    BranchService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    // StorageService,
    // ApiService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/app.module.ts